import { render, staticRenderFns } from "./bffTextLabel.vue?vue&type=template&id=0f146499&scoped=true&"
import script from "./bffTextLabel.vue?vue&type=script&lang=ts&"
export * from "./bffTextLabel.vue?vue&type=script&lang=ts&"
import style0 from "./bffTextLabel.vue?vue&type=style&index=0&id=0f146499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f146499",
  null
  
)

export default component.exports